import styled from 'styled-components';
import { elRed } from 'src/styles/colors';

// Spinning ring. Defaults suit a light background; pass $track/$accent for dark.
const Spinner = styled.div`
  width: ${props => props.$size || '26px'};
  height: ${props => props.$size || '26px'};
  border: 3px solid ${props => props.$track || 'rgba(0, 0, 0, 0.15)'};
  border-top-color: ${props => props.$accent || elRed};
  border-radius: 50%;
  animation: shared-spinner-spin 0.7s linear infinite;

  @keyframes shared-spinner-spin {
    to { transform: rotate(360deg); }
  }
`;

export default Spinner;
